// extracted by mini-css-extract-plugin
module.exports = {"debug":"chips_debug__1YV7K","chip":"chips_chip__3u_I1","selected":"chips_selected__1CvqP","icon":"chips_icon__2aFBr"};